import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './RealEstate.css';

const RealEstate = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Real Estate Services | Digi Network" 
                description="Learn more about our Real Estate services to grow your business online with Digi Network." 
                canonical="/industries/realestate/realestate" 
            />

            {/* Hero Section */}
            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">Real Estate Industry</div>
                        <h1>Digital Marketing for Real Estate</h1>
                        <p>Generate qualified leads, showcase properties, and build your real estate brand with targeted digital marketing strategies that convert browsers into buyers. We understand the unique challenges real estate professionals face in today's competitive market.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Image Section - Hero Image */}
            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add Real Estate Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            {/* Services Grid */}
            <section className="industry-services">
                <div className="container">
                    <h2>Real Estate Marketing Services</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for real estate professionals</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>Real Estate SEO</h3>
                            <p>Rank for local property searches, neighborhood keywords, and attract qualified buyers and sellers to your listings. Our real estate SEO strategies help you dominate local search results and build authority in your market area.</p>
                            <ul>
                                <li>Local SEO for real estate agents</li>
                                <li>Property listing optimization</li>
                                <li>Neighborhood-specific content</li>
                                <li>Google My Business for agents</li>
                                <li>Real estate directory listings</li>
                                <li>Market report content</li>
                            </ul>
                            <Link to="/industries/real-estate/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Real Estate Paid Ads</h3>
                            <p>Target qualified buyers and sellers with hyper-local advertising campaigns that drive leads and appointments. Our targeted ad campaigns reach people actively searching for properties in your service area.</p>
                            <ul>
                                <li>Facebook & Instagram property ads</li>
                                <li>Google Ads for real estate</li>
                                <li>Lead generation campaigns</li>
                                <li>Retargeting for property viewers</li>
                                <li>YouTube property video ads</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/real-estate/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Real Estate Website Design</h3>
                            <p>Professional agent websites with property listings, virtual tours, and lead capture forms that convert visitors. Our real estate websites are designed to showcase your properties and capture qualified leads.</p>
                            <ul>
                                <li>Property listing websites</li>
                                <li>IDX integration</li>
                                <li>Virtual tour integration</li>
                                <li>Lead capture optimization</li>
                                <li>Mobile-responsive design</li>
                                <li>Neighborhood pages</li>
                            </ul>
                            <Link to="/industries/real-estate/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Real Estate Email Marketing</h3>
                            <p>Nurture leads with automated email campaigns featuring new listings, market updates, and neighborhood insights. Build lasting relationships with clients through strategic email communication that provides value.</p>
                            <ul>
                                <li>New listing notifications</li>
                                <li>Market update newsletters</li>
                                <li>Lead nurturing sequences</li>
                                <li>Client retention campaigns</li>
                                <li>Open house invitations</li>
                                <li>Market trend reports</li>
                            </ul>
                            <Link to="/industries/real-estate/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Real Estate CRM & Automation</h3>
                            <p>Manage leads, automate follow-ups, and streamline client communication with GoHighLevel for real estate. Automate your lead management and client communication workflows to close more deals.</p>
                            <ul>
                                <li>Lead management system</li>
                                <li>Automated follow-up sequences</li>
                                <li>Multi-channel communication</li>
                                <li>Pipeline tracking & reporting</li>
                                <li>Client database management</li>
                                <li>Transaction automation</li>
                            </ul>
                            <Link to="/industries/real-estate/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Process Section */}
            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title">Our Real Estate Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for real estate professionals</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Market Analysis</h3>
                            <p>We analyze your local market, competition, and target audience to understand what drives real estate decisions in your area. Our team conducts comprehensive research to identify the best marketing opportunities.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Brand Development</h3>
                            <p>We help you build a strong personal brand that stands out in your market. From professional headshots to consistent messaging across all channels, we ensure you present a cohesive brand image.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Lead Generation</h3>
                            <p>We implement multi-channel marketing strategies to generate a steady stream of qualified leads. Our campaigns target both buyers and sellers actively searching for real estate services in your area.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Conversion & Growth</h3>
                            <p>We nurture leads through automated follow-up sequences and personalized communication. Our CRM system helps you track every lead and convert more prospects into clients.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Image Section - Process Image */}
            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Real Estate Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="why-choose">
                <div className="container">
                    <h2>Why Real Estate Agents Choose Digi Network</h2>
                    <p className="why-intro">Trusted by real estate professionals across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Lead Generation Focus</h3>
                            <p>Every strategy is designed to generate qualified leads and appointments, not just website traffic. We understand that real estate is a relationship business and focus on quality over quantity.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>Real Estate Expertise</h3>
                            <p>We understand the real estate market and create campaigns that speak to buyers and sellers. Our team has extensive experience working with real estate agents, brokers, and property management companies.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Proven Track Record</h3>
                            <p>We've helped real estate agents generate 500+ qualified leads per month through targeted campaigns. Our data-driven approach delivers measurable results that directly impact your business.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>ROI-Driven Results</h3>
                            <p>Transparent reporting showing lead quality, conversion rates, and ROI on every marketing dollar spent. We provide detailed analytics to help you understand exactly how your marketing is performing.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="benefits-section">
                <div className="container">
                    <h2>Key Benefits for Real Estate Agents</h2>
                    <p className="section-intro">How our marketing services help you grow your real estate business</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>More Qualified Leads</h3>
                            <p>Generate a steady stream of qualified leads who are actively looking to buy or sell properties. Our targeted campaigns reach people at the right time in their real estate journey.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Stronger Online Presence</h3>
                            <p>Build a professional online presence that showcases your expertise and listings. When potential clients search for real estate services, they'll find you first.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Client Relationships</h3>
                            <p>Automate follow-ups and nurture relationships with automated email campaigns. Keep in touch with past clients and turn them into repeat customers and referrals.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Increased Listings</h3>
                            <p>Attract more sellers through targeted marketing campaigns that showcase your track record and expertise. Build trust with property owners looking to sell.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Faster Deal Closures</h3>
                            <p>Streamline your sales process with automated lead management and follow-up systems. Close deals faster with organized client communication and tracking.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many real estate agents still rely on outdated marketing methods.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Image Section - Benefits Image */}
            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Real Estate Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="industry-cta">
                <div className="container">
                    <h2>Ready to Generate More Real Estate Leads?</h2>
                    <p>Let's discuss how we can help you attract more buyers and sellers to grow your real estate business.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default RealEstate;
